import { styled } from 'styled-components';

import SkeletonLine from '../SkeletonLine';

// The line that represents the loading state
export const Line = styled(SkeletonLine)`
  height: var(--font-lg);
`;
